export default "__VITE_ASSET__BHeLJMX3__"